<template>
  <div class="col-11 pl-0 ml-0">
    <v-row>
      <v-col class="pb-0">
        <p class="title pl-0 ml-0 mb-0">결제 내역</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card outlined>
          <v-data-table
            :headers="headers"
            :items="paymentInfos"
            :server-items-length="paymentInfosCount"
            :page.sync="page"
            :loading="tableLoading"
            :items-per-page="searchPayload.limit"
            hide-default-footer
            @page-count="pageCount = $event"
            class="elevation-1"
          >
            <template v-slot:item.order_name="{ item }" class="pl-0 pr-0">
              <p class="mb-0 text-center caption">{{ item.order_amount | numberFormat }}원 ({{ item.order_name }})</p>
            </template>
            <template slot="no-data">
              <div class="noDataProductInfos">내역이 없습니다.</div>
            </template>
          </v-data-table>
        </v-card>
        <div class="text-center mt-5">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
</style>
<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";

export default {
  data() {
    return {
      headers: [
        {
          text: "결제일시",
          align: "center",
          sortable: false,
          value: "paid_date",
        },
        {
          text: "주문번호",
          align: "center",
          sortable: false,
          value: "order_id",
        },
        {
          text: "결제내용",
          align: "center",
          sortable: false,
          value: "order_name",
        },
        {
          text: "시작일",
          align: "center",
          sortable: false,
          value: "start_date",
        },
        { text: "종료일", align: "center", sortable: false, value: "end_date" },
      ],
      page: 1,
      pageCount: 0,
      tableLoading: false,
      paymentInfos: [],
      paymentInfosCount: 0,
      searchPayload: {
        limit: 10,
        offset: 0,
      },
    };
  },
  mixins: [CommonMixin],
  filters: Filters,
  watch: {
    page: {
      handler() {
        this.getPaymentList();
      },
      deep: true,
    },
  },
  methods: {
    getPaymentList: async function() {
      this.searchPayload.offset = (this.page - 1) * this.searchPayload.limit;
      this.tableLoading = true;
      let res = await M.api(M.entry("/api/payments"), this.searchPayload);
      this.tableLoading = false;
      if (Object.prototype.hasOwnProperty.call(res, "payments")) {
        this.paymentInfos = res.payments;
        this.paymentInfosCount = res.payments_count;
      } else {
        this.tableLoading = false;
      }
    },
  },
  mounted: function() {
    this.getPaymentList();
  },
};
</script>
